import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { ApiCalls } from '../../api/api';
import { InitialData } from '../../api/generated/data-contracts';
import { INIT_DATA } from '../../constants/queryKeys';

export const configQKey = Object.freeze([INIT_DATA]);

export const useConfigValues = (
    options?: Omit<UseQueryOptions<InitialData, unknown, InitialData, string[]>, 'initialData' | 'queryKey' | 'queryFn'> & {
        initialData?: () => undefined;
    },
) => {
    return useQuery({
        queryKey: configQKey,
        queryFn: () => ApiCalls.getInitialData().then(res => res.data),
        useErrorBoundary: true,
        staleTime: Infinity,
        cacheTime: Infinity,
        ...options,
    });
};
